import React from 'react';

const Footer = ({ lang, t }) => {
  const isRtl = lang === 'ar';

  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = 80; 
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <footer style={{...styles.footer, direction: isRtl ? 'rtl' : 'ltr'}}>
      <div className="footer-container-flex" style={styles.container}>
        
        {/* 1. قسم التعريف */}
        <div className="footer-column brand-column">
          <h3 style={styles.brandTitle}>
            {lang === 'ar' ? 'يام انترناشونال للصناعات' : 'YAM INTERNATIONAL INDUSTRIES'}
          </h3>
          <p style={styles.brandDesc}>
            {lang === 'ar' 
              ? 'الجيل الثالث في تطوير وتصنيع المنظفات، جودة نثق بها عبر الأجيال.' 
              : '3rd Generation in Detergent Manufacturing, quality trusted across generations.'}
          </p>
        </div>

        {/* 2. روابط سريعة */}
        <div className="footer-column links-column">
          <h4 style={styles.subTitle}>{lang === 'ar' ? 'روابط سريعة' : 'Quick Links'}</h4>
          <nav style={styles.list}>
            <a href="#home" onClick={(e) => { e.preventDefault(); window.scrollTo({top:0, behavior:'smooth'}); }} style={styles.footerLink}>{t.nav.home}</a>
            <a href="#about" onClick={(e) => scrollToSection(e, 'about')} style={styles.footerLink}>{t.nav.about}</a>
            <a href="#yamshop" onClick={(e) => scrollToSection(e, 'yamshop')} style={styles.footerLink}>{t.nav.shop}</a>
          </nav>
        </div>

        {/* 3. التواصل الاجتماعي */}
        <div className="footer-column links-column">
          <h4 style={styles.subTitle}>{lang === 'ar' ? 'تابعنا' : 'Follow Us'}</h4>
          <nav style={styles.list}>
            <a href="https://www.facebook.com/Yaminternationalindustries" target="_blank" rel="noreferrer" style={styles.footerLink}>Facebook</a>
            <a href="https://www.instagram.com/yam.egy24/" target="_blank" rel="noreferrer" style={styles.footerLink}>Instagram</a>
            <a href="https://www.linkedin.com/company/yam-international-industries" target="_blank" rel="noreferrer" style={styles.footerLink}>LinkedIn</a>
          </nav>
        </div>
        
        {/* 4. معلومات الاتصال - تم التوحيد لتتناسق مع الهاتف */}
        <div className="footer-column contact-column">
          <h4 style={styles.subTitle}>{lang === 'ar' ? 'اتصل بنا' : 'Contact Us'}</h4>
          
          <div style={styles.contactItemContainer}>
            <span style={styles.contactIcon}>📞</span>
            <span style={{ direction: 'ltr' }}>02 28590490</span>
          </div>

          <div style={styles.contactItemContainer}>
            <span style={styles.contactIcon}>✉️</span>
            <span>info@yam-ii.com</span>
          </div>

          <div style={styles.contactItemContainer}>
            <span style={styles.contactIcon}>📍</span>
            <span>{lang === 'ar' ? 'مدينة بدر، المنطقة الصناعية' : 'Badr City, Industrial Area'}</span>
          </div>
        </div>

      </div>
      
      {/* الحقوق السفلي */}
      <div style={styles.copyrightBar}>
        <div className="footer-container-flex">
          <p style={styles.copyText}>
            {lang === 'ar' 
              ? `© ${new Date().getFullYear()} جميع الحقوق محفوظة لشركة يام انترناشونال للصناعات` 
              : `© ${new Date().getFullYear()} All Rights Reserved to YAM INTERNATIONAL INDUSTRIES`}
          </p>
		  
		  <p style={{ ...styles.copyText, fontSize: '0.8rem', opacity: 0.8 }}>
           {lang === 'ar' 
           ? 'تم التطوير بواسطة ' 
           : 'Developed by '}
          <span style={{ color: '#d4af37', fontWeight: 'bold' }}>EsprivaLab</span>
    </p>  
		  
		  
        </div>
      </div>

      <style>{`
        .footer-container-flex {
          width: 92%;
          max-width: 1400px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 40px;
        }

        .footer-column {
          flex: 1;
          min-width: 250px;
        }

        .brand-column { flex: 1.8; }

        @media (max-width: 991px) {
          .footer-column { min-width: 45%; }
        }

        @media (max-width: 600px) {
          .footer-container-flex {
            flex-direction: column;
            text-align: center;
            align-items: center;
            gap: 50px;
          }
          .footer-column { width: 100%; min-width: 100%; }
          /* محاذاة العناصر للوسط في الموبايل */
          div[style*="display: flex"] { justify-content: center; }
        }
      `}</style>
    </footer>
  );
};

const styles = {
  footer: { 
    background: '#0d1f33', 
    color: '#fff', 
    padding: '80px 0 0 0', 
    borderTop: '5px solid #d4af37',
    width: '100%'
  },
  container: { paddingBottom: '60px' },
  brandTitle: { 
    color: '#d4af37', 
    marginBottom: '25px', 
    fontSize: 'clamp(1.5rem, 2vw, 1.8rem)', 
    fontWeight: '900',
    lineHeight: '1.2'
  },
  brandDesc: { 
    color: '#e2e8f0', 
    lineHeight: '1.8', 
    fontSize: '1.15rem',
    fontWeight: '500'
  },
  subTitle: { 
    color: '#d4af37', 
    marginBottom: '30px', 
    fontSize: '1.3rem', 
    fontWeight: '800',
    textTransform: 'uppercase',
    letterSpacing: '1px'
  },
  list: { display: 'flex', flexDirection: 'column', gap: '15px' },
  footerLink: { 
    color: '#cbd5e1', 
    textDecoration: 'none', 
    fontSize: '1.1rem', 
    fontWeight: '600',
    transition: '0.3s',
    cursor: 'pointer'
  },
  
  /* ستايل موحد لعناصر الاتصال */
  contactItemContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '18px',
    color: '#cbd5e1',
    fontSize: '1.1rem',
    fontWeight: '600'
  },
  contactIcon: {
    fontSize: '1.4rem',
    display: 'inline-block',
    width: '25px',
    textAlign: 'center'
  },

  copyrightBar: { 
    borderTop: '1px solid rgba(212,175,55,0.2)', 
    padding: '30px 0', 
    marginTop: '20px',
    backgroundColor: 'rgba(0,0,0,0.3)' 
  },
  copyText: { 
    textAlign: 'center', 
    color: '#94a3b8', 
    fontSize: '1rem', 
    fontWeight: '700',
    width: '100%', 
    margin: 0 
  }
};

export default Footer;